import { defineStore } from "pinia"
import { ref } from "vue"

export const useUiStore = defineStore("ui", () => {
  // State
  const appNavDrawer = ref<boolean>(false)
  // Future transient UI state can go here
  // const modalStack = ref<any[]>([])
  // const loadingStates = ref<Record<string, boolean>>({})
  // etc.

  // Actions
  function toggleAppNavDrawer(): void {
    appNavDrawer.value = !appNavDrawer.value
  }

  function openAppNavDrawer(): void {
    appNavDrawer.value = true
  }

  function closeAppNavDrawer(): void {
    appNavDrawer.value = false
  }

  return {
    // State
    appNavDrawer,

    // Actions
    toggleAppNavDrawer,
    openAppNavDrawer,
    closeAppNavDrawer,
  }
})
